// UK date/time formatting — DD/MM/YYYY and 24-hour HH:mm.
// Date-only values (YYYY-MM-DD) are formatted as a plain calendar date with no
// timezone conversion (prevents off-by-one day shifts). Timestamps are shown in UK time.

const TZ = "Europe/London";
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

function parseDateOnly(v) {
  const m = String(v).slice(0, 10);
  if (DATE_ONLY.test(m)) {
    const [y, mo, d] = m.split("-");
    return `${d}/${mo}/${y}`;
  }
  return null;
}

export function fmtDate(v, fallback = "—") {
  if (v == null || v === "") return fallback;
  const only = parseDateOnly(v);
  if (only) return only;
  const dt = new Date(v);
  if (isNaN(dt.getTime())) return fallback;
  return new Intl.DateTimeFormat("en-GB", { timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric" }).format(dt);
}

export function fmtTime(v, fallback = "—") {
  if (v == null || v === "") return fallback;
  const dt = new Date(v);
  if (isNaN(dt.getTime())) return fallback;
  return new Intl.DateTimeFormat("en-GB", { timeZone: TZ, hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).format(dt);
}

export function fmtDateTime(v, fallback = "—") {
  if (v == null || v === "") return fallback;
  if (DATE_ONLY.test(String(v).trim())) return fmtDate(v, fallback); // true date-only, no time component
  const dt = new Date(v);
  if (isNaN(dt.getTime())) return fallback;
  return `${fmtDate(v)} ${fmtTime(v)}`;
}


// Local (device) date / time parts for back-datable payment & handover pickers.
export function todayIso() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
export function nowHM() {
  const d = new Date();
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}
// Split an ISO timestamp into { date: YYYY-MM-DD, time: HH:MM } in local time.
export function splitIso(iso) {
  if (!iso) return { date: todayIso(), time: nowHM() };
  const dt = new Date(iso);
  if (isNaN(dt.getTime())) return { date: todayIso(), time: nowHM() };
  return {
    date: `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`,
    time: `${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`,
  };
}
